import React from "react";
import backArrow from "../../../assets/icons/Back.svg";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import bettingService from "../../../api/services/bettingService";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { playSong } from '../../common/actions/common.actions';
import { IoIosArrowBack } from "react-icons/io";

const OldMatchesPage = ({ setIsLoading }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { oldHistory } = useSelector(state => state.sidebar);
    const { id } = useParams();
    const { t } = useTranslation();
    const [oldMatches, setOldMatches] = useState([]);
    const language = localStorage.getItem("language");
    const profitAmount = oldHistory ? (oldHistory?.profitAmount >= 0 ? oldHistory.profitAmount : 0) : 0;
    const winAmount = Math.max(profitAmount - (oldHistory?.amount || 0), 0);

    const handleBackClick = async () => {
        dispatch(playSong());
        navigate("/old-histories");
    };

    useEffect(() => {
        setIsLoading(true);
        bettingService.bettingHistoryDetails({
            "gamblingId": Number(id),
            "status": "Finished"
        })
            .then(response => response.json())
            .then(data => {
                if (data) {
                    const sortedData = data.slice().sort((a, b) => {
                        const dateA = new Date(
                            a.eventDate.split(' ')[0].split('-').reverse().join('-') + ' ' + a.eventDate.split(' ')[1]
                        );
                        const dateB = new Date(
                            b.eventDate.split(' ')[0].split('-').reverse().join('-') + ' ' + b.eventDate.split(' ')[1]
                        );
                        return dateA - dateB;
                    });
                    setOldMatches(sortedData)
                }
                setIsLoading(false);
            })
            .catch(err => {
                setIsLoading(false);
                console.error("API request error:", err);
            });
    }, [id, navigate, setIsLoading]);

    return (
        <div className="w-full h-screen flex flex-col dark:bg-bg_header_dark overflow-hidden">
            <div className="flex justify-start items-center py-2 border-b dark:border-b dark:border-slate-700 dark:shadow-sm bg-gradient-to-r from-slate-300 to-slate-100 dark:bg-bg_header_dark">
                <button
                    className="top-3 left-5 w-10 h-10
                    rounded-full drop-shadow-lg flex justify-center items-center text-white text-4xl"
                    onClick={handleBackClick}
                >
                    {/* <img src={backArrow} alt="Back Arrow" /> */}
                    <IoIosArrowBack size={25} color="#000000" />
                </button>
                <div className="flex-1 justify-center items-center">
                    <h3 className="text-wtext font-bold font-myanmarSansPro mr-7 text-start ml-2 dark:text-whitev1">
                        {t("oldMatches")}
                    </h3>
                </div>
            </div>
            <div className="text-primary dark:text-league_text text-end text-sm mr-3 mt-2 font-dangrek">BetID : {oldHistory?.postingNo}</div>
            <div className="flex-1 p-2 overflow-auto font-bold font-myanmarSansPro">
                {oldMatches.map((match, index) => {
                    const bettedTeam = language === "en" ? match?.bettedTeam : match?.bettedTeamMyan;
                    const oppositeTeamName = language === "en" ? match?.oppositeTeamName : match?.oppositeTeamNameMyan;
                    return (
                        <div key={index} className="flex flex-col py-2 px-2 mb-2 rounded-md bg-slate-200">
                            <div className="flex justify-between items-center mb-1  text-xs sm:text-sm md:text-base text-k_leagueFgColor dark:text-white">
                                <p className="text-left rounded-lg font-normal text-waterThree dark:text-black font-dangrek">
                                    {match?.eventDate}
                                </p>
                            </div>
                            <div className="grid grid-cols-9 gap-[1px] mb-1">
                                <div
                                    className={`${match?.home === true
                                        ? "dark:bg-k_selectionBgColor bg-gradient-to-r from-waterThree via-waterThree to-waterTwo"
                                        : "dark:bg-k_teamsBgColor bg-wback dark:text-k_teamsFgColor"
                                        } rounded-full py-[11px] px-1 flex items-center col-span-4`}
                                >
                                    <h3
                                        className={`ml-auto font-bold text-center dark:text-white text-sm ${match?.home === true ? "text-k_selectionFgColor" : "text-wtext"
                                            } sm:text-base md:text-base ${match?.isHomeBodyOdd === false
                                                ? "flex flex-1 items-center justify-center"
                                                : "flex flex-1 justify-center"
                                            }`}
                                    >
                                        {match.isHome ? bettedTeam : oppositeTeamName}
                                    </h3>
                                    {match.isHomeBodyOdd === true && (
                                        <h3 className="bg-waterFour p-1 rounded-full text-wback font-bold text-xxs text-xs sm:text-sm md:text-base whitespace-nowrap">
                                            {match?.bodyOdd}
                                        </h3>
                                    )}
                                </div>
                                {/* <div className="flex flex-row justify-center gap-[1px]">
                                    <div className="cursor-not-allowed text-center w-[20px] bg-red-600 rounded-md p-[3px] flex justify-center items-center ">
                                        <h3 className="font-semibold text-center text-[#fff] text-base sm:text-sm md:text-base">
                                            {match?.homeResult}
                                        </h3>
                                    </div>
                                    <div className="cursor-not-allowed text-center w-[20px] bg-red-600 rounded-md p-[3px] flex justify-center items-center ">
                                        <h3 className="font-semibold text-center text-[#fff] text-base sm:text-sm md:text-base">
                                            {match?.awayResult}
                                        </h3>
                                    </div>
                                </div> */}
                                <div className="flex justify-center items-center text-white text-center text-xs w-full rounded-full bg-waterOne font-dangrek">
                                        {`${match?.homeResult}-${match?.awayResult}`}
                                </div>
                                <div
                                    className={`${match?.away === true
                                        ? "dark:bg-k_selectionBgColor bg-gradient-to-r from-waterTwo via-waterThree to-waterThree text-wback "
                                        : "dark:bg-k_teamsBgColor bg-wback text-wtext dark:text-k_teamsFgColor"
                                        } rounded-full py-[11px] px-1 flex justify-center items-center col-span-4`}
                                >
                                    {match?.isHomeBodyOdd === false && (
                                        <h3 className="bg-waterFour text-wback price p-1 font-bold rounded-full text-xxs text-xs sm:text-sm md:text-base">
                                            {match?.bodyOdd}
                                        </h3>
                                    )}
                                    <h3
                                        className={` flex flex-1 w-full justify-center text-center dark:text-white text-sm sm:text-base md:text-base ${match?.isHomeBodyOdd === true &&
                                            "flex flex-1 justify-center items-center"
                                            }`}
                                    >
                                        {!match.isHome ? bettedTeam : oppositeTeamName}
                                    </h3>
                                </div>
                            </div>
                            <div className="grid grid-cols-5 gap-1">
                                <div
                                    className={`${match?.overs === true
                                        ? "dark:bg-k_selectionBgColor bg-gradient-to-r from-waterThree via-waterThree to-waterTwo text-wback "
                                        : "dark:bg-k_teamsBgColor bg-wback text-wtext dark:text-k_teamsFgColor"
                                        } rounded-full p-1 col-span-2`}
                                >
                                    <h3 className="text-center  dark:text-white text-sm sm:text-sm md:text-base py-2">
                                        {t("goalOver")}
                                    </h3>
                                </div>
                                <div className="cursor-not-allowed text-center bg-k_priceBgColor rounded-full p-1 flex justify-center items-center ">
                                    <h3 className="font-bold text-center text-k_priceFgColor text-xs  sm:text-sm md:text-base">
                                        {match?.goalOdd}
                                    </h3>
                                </div>
                                <div
                                    className={`${match?.under === true
                                        ? "dark:bg-k_selectionBgColor bg-gradient-to-r from-waterTw via-waterThree to-waterThree text-wback "
                                        : "dark:bg-k_teamsBgColor bg-wback text-wtext dark:text-k_teamsFgColor"
                                        } text-center rounded-full p-1 col-span-2 flex justify-center items-center`}
                                >
                                    <h3 className="text-center dark:text-white text-sm sm:text-sm md:text-base">
                                        {t("goalUnder")}
                                    </h3>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
            <div className="w-full flex flex-col bg-gradient-to-r from-slate-300 to-slate-100 dark:border-t-2  border-slate-500 dark:border-black/[0.2] dark:bg-bg_header_dark dark:text-white font-dangrek text-cus4 h-max pl-20 py-4">
                <div className="grid grid-cols-2 gap-4 py-1">
                    <h4 className="font-bold font-myanmarSansPro">{t("betAmount")}</h4>
                    <p >{oldHistory?.amount}</p>
                </div>
                <div className="grid grid-cols-2 gap-4 py-1">
                    <h4 className="font-bold font-myanmarSansPro">{t("profitAmount")}</h4>
                    <p>{profitAmount}</p>
                </div>
                <div className="grid grid-cols-2 gap-4 py-1">
                    <h4 className="font-bold font-myanmarSansPro">{t("winAmount")}</h4>
                    <p className="text-blue-600">{winAmount}</p>
                </div>
            </div>
        </div>
    );
}

export default OldMatchesPage;
